import * as React from 'react';
import styled from 'styled-components';
import type { Group } from '../../containers/GroupsList/groupsSlice/types';
import { palette } from '../../theme/colors';
import { useImage } from '../../utils/customHooks/useImage';
import { GroupType, groupTypeNames } from '../../utils/enums';
import { translate } from '../../utils/translate';
import type { ICheckBoxWithSubTitleProps } from '../CheckBoxWithSubTitle/CheckBoxWithSubTitle';
import { CheckBoxWithSubTitle } from '../CheckBoxWithSubTitle/CheckBoxWithSubTitle';
import { HighlightSearchTerm } from '../Checklists/HighlightSearchTerm/HighlightSearchTerm';
const SCheckBoxWithSubTitle = styled(CheckBoxWithSubTitle)`
  .STitle {
    font-family: 'Roboto-Regular';
  }
`;
type IIamOkGroupSelectItemProps = {
  group: Group;
  withSubtitle?: boolean;
  searchTerm?: string;
} & Omit<ICheckBoxWithSubTitleProps, 'title' | 'valueId'>;

export const IamOkGroupSelectItem = (props: IIamOkGroupSelectItemProps) => {
  const { searchTerm, group, selected, onToggleCheck, withSubtitle, ...res } = props;
  const { img } = useImage({ imageName: group.imageFileName });
  const isNotNormal =
    group.groupType === GroupType.Hidden ||
    group.groupType === GroupType.CrossOrg ||
    group.groupType === GroupType.CoAlert;
  return (
    <SCheckBoxWithSubTitle
      withPhoto
      selected={selected}
      photoUrl={img}
      subTitle={
        withSubtitle
          ? isNotNormal
            ? translate(groupTypeNames[group.groupType as GroupType])!
            : group.membersCount.toString() + ' ' + translate('groups_members')!
          : undefined
      }
      title={HighlightSearchTerm(group.name, searchTerm)}
      valueId={group.id}
      onToggleCheck={onToggleCheck}
      separatorColor={palette.prussianBlue4}
      clickAll
      {...res}
    />
  );
};
